import { Spinner } from 'components/ui';
import { useOrgRedirect } from './utils';

export default function OrgRedirect() {
  useOrgRedirect();
  return <Spinner />;
}
